import { Flex, Grid, theme } from '@aloft/toolkit-sui';

import { logger } from '../../logging/logging.ts';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary.tsx';
import { ColumnErrorBoundaryFallback } from './ColumnErrorBoundaryFallback.tsx';
import { LabelColumnHeaderSection } from './columnSections/LabelColumnHeaderSection.tsx';
import { LabelColumnSubHeader } from './columnSections/PropertyGridColumnSubHeader.tsx';
import { GRID_BORDER, LABEL_COLUMN_WIDTH } from './consts.ts';
import {
  PropertyGridColumnSectionComponent,
  PropertyGridSectionProps,
  PropertyGridType,
} from './types.ts';

type PropertyGridColumnProps = {
  columnSections: PropertyGridColumnSectionComponent[];
  gridType: PropertyGridType;
  headerContent: React.ReactNode;
  hasUnitRate: boolean;
} & Pick<PropertyGridSectionProps, 'control' | 'getValues' | 'setValue'>;

const log = logger();

export const PropertyGridLabelColumn = ({
  columnSections,
  gridType,
  headerContent,
  control,
  getValues,
  setValue,
  hasUnitRate
}: PropertyGridColumnProps) => {
  const gridSectionProps: PropertyGridSectionProps = {
    fieldTypes: ['label'],
    gridType,
    columnIndex: -1,
    control,
    getValues,
    setValue,
    hasUnitRate
  };

  return (
    <ErrorBoundary
      Fallback={ColumnErrorBoundaryFallback}
      onError={() => log.fatal('Failed to display Property Grid Label Column')}
    >
      <Flex
        zIndex={theme.zIndices.sticky}
        backgroundColor="surface1"
        flexDirection="column"
        height="100%"
        position="sticky"
        left={0}
        width={LABEL_COLUMN_WIDTH}
        __dangerDoNotUseSx={{ borderTop: 'none' }}
      >
        <LabelColumnHeaderSection content={headerContent} />
        <Grid
          backgroundColor="strokeDefault"
          gap="1px"
          __dangerDoNotUseSx={{
            borderRight: GRID_BORDER,
            borderBottom: GRID_BORDER,
            borderLeft: GRID_BORDER,
          }}
        >
          <LabelColumnSubHeader />
          {columnSections.map((Section) => (
            <Section key={`label-column-${Section.name}-section`} {...gridSectionProps} />
          ))}
        </Grid>
      </Flex>
    </ErrorBoundary>
  );
};
